/* eslint-disable */
import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { useTranslation } from "react-i18next";

import CardImage from '../../components/card-image'
import { TitleOne, TextBodyOne } from '../../components/text'
import OnDemandBody from '../../static/images/massage/on-demand-body.svg'
import OnDemandReflexology from '../../static/images/massage/on-demand-reflexology.svg'
import OnDemandFullKerokan from '../../static/images/massage/on-demand-full-kerokan.svg'
import Background from '../../static/images/massage/background-on-demand.svg'
import { DemandStyle } from './on-demand-styles'

const OnDemand = () => {
  const { t } = useTranslation();

  return (
    <DemandStyle>
      <div className="background-image">
        <img src={Background} alt="halojasa/image-background" loading="lazy" />
      </div>
      <Grid>
        <Row between="lg">
          <Col sm={12} xs={12} md={12} lg={3}>
            <Row>
              <Col sm={12} xs={12} md={12} lg={12} className="bottom-margin">
                <TitleOne display="block" align="left">
                  {t('pageBodyMassageJakarta.part25')}
                </TitleOne>
                <div className="top-margin">
                  <TextBodyOne display="block" align="left">
                    {t('pageBodyMassageJakarta.part26')}
                  </TextBodyOne>
                </div>
              </Col>
            </Row>
          </Col>
          <Col sm={12} xs={12} md={12} lg={8}>
            <Row className="scroll-row">
              <Col className="scroll-col" sm={12} xs={12} md={4} lg={4}>
                <CardImage
                  className="card-shadow"
                  titleTop={false}
                  image={OnDemandBody}
                  title={t('pageBodyMassageJakarta.part27')}
                  desc={t('pageBodyMassageJakarta.part28')}
                ></CardImage>
              </Col>
              <Col className="scroll-col" sm={12} xs={12} md={4} lg={4}>
                <CardImage
                  className="card-shadow"
                  titleTop={false}
                  image={OnDemandReflexology}
                  title={t('pageBodyMassageJakarta.part29')}
                  desc={t('pageBodyMassageJakarta.part30')}
                ></CardImage>
              </Col>
              <Col className="scroll-col" sm={12} xs={12} md={4} lg={4}>
                <CardImage
                  className="card-shadow"
                  titleTop={false}
                  image={OnDemandFullKerokan}
                  title={t('pageBodyMassageJakarta.part31')}
                  desc={t('pageBodyMassageJakarta.part32')}
                ></CardImage>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    </DemandStyle>
  )
}

export default OnDemand
